import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { UserInfoService } from "../services/user-info/user-info.service";

@Injectable({
  providedIn: 'root'
})
export class CheckUrlAccessGuard {

  constructor(
    private readonly userInfoService: UserInfoService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.userInfoService.getAuthAutorisations().some(auth => route.data.authorisation.includes(auth));
  }

}
